var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},_vm._l((_vm.menuItems),function(item,index){return _c('div',{key:index,staticClass:"p-3"},[_c('router-link',{attrs:{"to":item.link}},[_c('span',[_c('i',{staticClass:"mx-3",class:item.icon}),_vm._v(_vm._s(item.name))])])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }